import isUnauthorizedResponse from '../isUnauthorizedResponse';
export default function performReauth(reauth, apiContext) {
    return reauth()
        .then(reauthResponse => {
        apiContext.setTokens(reauthResponse.data);
        return {
            auth: {
                isNotAuthenticated: false,
                newTokenData: reauthResponse.data,
            },
        };
    })
        .catch(reauthError => {
        if (isUnauthorizedResponse(reauthError)) {
            apiContext.clearTokens();
            return {
                auth: {
                    isNotAuthenticated: true,
                },
            };
        }
        return {
            auth: {
                isNotAuthenticated: false,
            },
        };
    });
}
